function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPamphletFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.968 28h-12V11.812h12V28zM6.031 20.188V4H16.99l-4.81 6.198a.994.994 0 00-.11.193c-.008.014-.018.026-.024.04-.006.012-.009.026-.014.04-.009.026-.012.055-.02.084a.96.96 0 00-.036.215c0 .014-.007.027-.007.042v9.376H6.031zm12-14.268v3.892h-3.02l3.02-3.892zm8.937 3.892h-6.937V3c0-.024-.009-.046-.01-.069a1.008 1.008 0 00-.068-.296c-.009-.025-.012-.05-.024-.075-.014-.028-.036-.05-.052-.077a.893.893 0 00-.191-.226c-.03-.026-.057-.052-.09-.075a.964.964 0 00-.17-.09c-.025-.01-.046-.029-.07-.038-.008-.002-.016 0-.023-.004a1.054 1.054 0 00-.213-.037c-.027-.003-.054-.012-.083-.012H5.031a1 1 0 00-1 1v18.187a1 1 0 001 1h6.937V29a1 1 0 001 1h14a1 1 0 001-1V10.812a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconPamphletFilled;